module.exports = __webpack_public_path__ + "static/media/work-12.963d7b2f.jpg";